import { getAPIPath, requestGooseAPI } from '../shared/request'
import {
  BookingReservationClientDto,
  CLIENT_BOOKING_PAYMENT_PATH,
  CLIENT_BOOKING_CONFIRM_PATH,
  CLIENT_BOOKING_PAYMENT_CANCEL_PATH,
  SubmitPaymentInput,
  CLIENT_BOOKING_PAYMENT_SUBMIT_PATH,
  OrderPaymentStepDto,
  CLIENT_BOOKING_PAYMENT_STEP_PATH,
} from '../types'

const goosePayment = (
  locationName: string,
  orderId: string,
  type: string,
  moreData: Record<string, string> = {}
): Promise<BookingReservationClientDto> => {
  return requestGooseAPI<BookingReservationClientDto>({
    url: getAPIPath(CLIENT_BOOKING_CONFIRM_PATH, { locationId: locationName, orderId }),
    method: 'POST',
    data: {
      payment: {
        type,
        ...moreData,
      },
    },
  })
}

interface TClientBookingPaymentService {
  initializePayment: (
    locationName: string,
    orderId: string,
    walletAmount?: number
  ) => Promise<BookingReservationClientDto>
  getStep: (locationName: string, orderId: string, paymentId: string) => Promise<OrderPaymentStepDto>
  submitPayment: (locationName: string, orderId: string, data: SubmitPaymentInput) => Promise<void>
  cancelPayment: (locationName: string, orderId: string, paymentId: string) => Promise<BookingReservationClientDto>
  offlinePayment: (locationName: string, orderId: string) => Promise<BookingReservationClientDto>
  voucherCashPayment: (locationName: string, orderId: string) => Promise<BookingReservationClientDto>
  tilledPayment: (locationName: string, orderId: string) => Promise<BookingReservationClientDto>
  adyenPayment: (locationName: string, orderId: string, sessionResult: string) => Promise<BookingReservationClientDto>
}
export const ClientBookingPaymentService: TClientBookingPaymentService = {
  initializePayment: (
    locationName: string,
    orderId: string,
    walletAmount?: number
  ): Promise<BookingReservationClientDto> => {
    return requestGooseAPI<BookingReservationClientDto>({
      url: getAPIPath(CLIENT_BOOKING_PAYMENT_PATH, { locationId: locationName, orderId }),
      method: 'POST',
      data: {
        payment: walletAmount ? { walletAmount } : {},
      },
    })
  },
  cancelPayment: (locationName: string, orderId: string, paymentId: string) =>
    requestGooseAPI<BookingReservationClientDto>({
      url: getAPIPath(CLIENT_BOOKING_PAYMENT_CANCEL_PATH, { locationId: locationName, orderId, paymentId }),
      method: 'PUT',
    }),

  submitPayment: (locationName: string, orderId: string, data: SubmitPaymentInput): Promise<void> => {
    return requestGooseAPI<void>({
      url: getAPIPath(CLIENT_BOOKING_PAYMENT_SUBMIT_PATH, { locationId: locationName, orderId }),
      method: 'POST',
      data,
    })
  },

  getStep: (locationName: string, orderId: string, paymentId: string): Promise<OrderPaymentStepDto> => {
    return requestGooseAPI<OrderPaymentStepDto>({
      url: getAPIPath(CLIENT_BOOKING_PAYMENT_STEP_PATH, { locationId: locationName, orderId, id: paymentId }),
      method: 'GET',
    })
  },

  offlinePayment: (locationName: string, orderId: string) => goosePayment(locationName, orderId, 'OFFLINE'),
  voucherCashPayment: (locationName: string, orderId: string) => goosePayment(locationName, orderId, 'VOUCHER_CASH'),
  tilledPayment: (locationName: string, orderId: string) => goosePayment(locationName, orderId, 'TILLED'),
  adyenPayment: (locationName: string, orderId: string, sessionResult: string) =>
    goosePayment(locationName, orderId, 'ADYEN', { sessionResult }),
}
